import './ShoppingCartBar.less';

export const prefix = 'oc-c-shopping-cart';

export { default } from './ShoppingCartBar';